import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AliadoUsuario } from '../../_models/aliado-usuario';
import { AliadoUsuarioService } from '../../_services/aliado-usuario.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Usuario } from '../../_models/usuario';
import { UsuariosService } from '../../_services/usuarios.service';
import { BusquedaFiltros } from '../../_models/busqueda-filtros';
import { AliadoSucursal } from '../../_models/aliado-sucursal';
import { Utilidades } from '../../utils/utilidades';
import {DominiosCorreosService} from '../../_services/dominios-correos.service';

@Component( {
  selector: 'app-aliados-usuarios-editar',
  templateUrl: 'aliados-usuarios-editar.component.html'
} )

export class AliadosUsuariosEditarComponent implements OnInit {

  @Input() aliado: AliadoUsuario;
  @Input() sucursal: AliadoSucursal;
  @Output() camSeccion: EventEmitter<boolean> = new EventEmitter();
  carInformacionInicial = true;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  resUsuarios: Usuario[] = [];
  idUsuarioTemporal: string;
  usuExiste = false;
  utilidades: Utilidades = new Utilidades();


  constructor( private aliUsuariosServicio: AliadoUsuarioService,
               private conServicio: ConfirmationService,
               private nav: NavService,
               private usuServicio: UsuariosService,
               private fb: FormBuilder,
               private dominios : DominiosCorreosService,) {
  }

  ngOnInit(): void {
    const usuario = new Usuario();
    if ( this.aliado ) {
      usuario.usuarioSistema = this.aliado.usuarioSistema;
    }
    this.idUsuarioTemporal = this.aliado ? this.aliado.idUsuario : null;
    this.formulario = this.fb.group( {
      idAliadoUsuario: [ this.aliado ? this.aliado.idAliadoUsuario : null ],
      idUsuario: [ this.aliado ? this.aliado.idUsuario : null, [ Validators.required ] ],
      usuario: [ usuario.nombre ],
      idAliadoSucursal: [ this.aliado ? this.aliado.idAliadoSucursal : this.sucursal.idAliadoSucursal, [ Validators.required ] ],
      telefono: [ this.aliado ? this.utilidades.cambiarTelefono( this.aliado.telefono ) : null, [ Validators.required, Validators.pattern( '\\(\\d{3}\\) \\d{3}-\\d{4}' ) ] ],
      correoElectronico: [ this.aliado ? this.aliado.correoElectronico : null, [ Validators.required, Validators.maxLength( 100 ), Validators.pattern( '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$' ) ] ],
      imei: [ this.aliado ? this.aliado.imei : null ],
      indicadorValidarUbicacion: [ this.aliado ? this.aliado.indicadorValidarUbicacion : true ],
      indicadorCheckIn: [ this.aliado ? this.aliado.indicadorCheckIn : false ],
      indicadorHabilitado: [ this.aliado ? this.aliado.indicadorHabilitado : true ]
    } );
    if ( !this.f.indicadorCheckIn.value ) {
      this.f.indicadorCheckIn.disable();
    }
    this.carInformacionInicial = false;
  }

  actualizarAliado( aliado: any ) {
    this.aliUsuariosServicio.actualizar( aliado ).subscribe( l => {
      this.actualizarUsuario( 2 );
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      this.usuExiste = false;
      const aliado = this.formulario.getRawValue();
      this.usuServicio.viewUserByEmail( this.f.correoElectronico.value ).subscribe( userMail => {
        if ( !userMail || ( userMail && userMail.idUsuario === this.f.idUsuario.value ) ) {
          if ( aliado.idAliadoUsuario ) {
            if ( aliado.indicadorHabilitado && aliado.indicadorHabilitado !== this.aliado.indicadorHabilitado ) {
              this.aliUsuariosServicio.obtenerPorUsuarioHabilitado( aliado.idUsuario ).subscribe( aliUsuario => {
                if ( aliUsuario && aliUsuario.idAliadoUsuario ) {
                  this.usuExiste = true;
                  this.guardando = false;
                } else {
                  this.aliUsuariosServicio.actualizarAliado( aliado.idUsuario, aliado.indicadorHabilitado ).subscribe( r => {
                    this.actualizarAliado( aliado );
                  } );
                }
              } );
            } else if ( aliado.indicadorHabilitado !== this.aliado.indicadorHabilitado ) {
              this.aliUsuariosServicio.actualizarAliado( aliado.idUsuario, aliado.indicadorHabilitado ).subscribe( r => {
                this.actualizarAliado( aliado );
              } );
            } else {
              this.actualizarAliado( aliado );
            }
          } else {
            this.aliUsuariosServicio.listadoPorUsuario( aliado.idUsuario ).subscribe( aliUsuarios => {
              const exiActual = aliUsuarios.find( x => x.indicadorHabilitado || x.idAliadoSucursal === aliado.idAliadoSucursal );
              if ( exiActual ) {
                this.usuExiste = true;
                this.guardando = false;
              } else {
                this.aliUsuariosServicio.crear( aliado ).subscribe( a => {
                  if ( aliado.indicadorHabilitado ) {
                    this.aliUsuariosServicio.actualizarAliado( aliado.idUsuario, true ).subscribe( rta => {
                      this.actualizarUsuario( 1 );
                    } );
                  } else {
                    this.actualizarUsuario( 1 );
                  }
                } );
              }
            } );
          }
        } else {
          this.nav.setMesage( 0, {
            severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.nav.buscarMensaje( 'ALIADOSUSUARIOS.MSG_EXISTECORREOUSUARIO' )
          } );
          this.guardando = false;
        }
      } );
    }
  }

  actualizarUsuario( tipo: number ) {
    this.usuServicio.getByIdFull( this.f.idUsuario.value ).subscribe( u => {
      u.celular = this.utilidades.quitarMascaraTelefono( this.f.telefono.value );
      u.correoElectronico = this.f.correoElectronico.value;
      this.usuServicio.updateUser( u ).subscribe( l => {
        this.guardando = false;
        this.nav.setMesage( tipo );
        this.camSeccion.emit( true );
      } );
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.nav.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'aliado-editar',
        accept: () => {
          this.camSeccion.emit( false );
        },
        reject: () => {
        }
      } );
    } else {
      this.camSeccion.emit( false );
    }
  }

  buscar( busqueda: any ) {
    const dato = new BusquedaFiltros();
    if ( busqueda.query ) {
      dato.query = busqueda.query.trim();
    }

    if ( dato.query && dato.query.length > 0 ) {
      this.usuServicio.buscarAutocomplete( dato ).subscribe( res => {
        this.resUsuarios = res.filter( x => x.indicadorHabilitado );
      } );
    } else {
      this.resUsuarios = [];
    }

  }

  capturarUsuario( usuario: any ) {
    console.log( usuario );
    this.f.idUsuario.setValue( usuario.value.idUsuario );
    this.f.telefono.setValue( this.utilidades.cambiarTelefono( usuario.value.celular ) );
    this.f.correoElectronico.setValue( usuario.value.correoElectronico );
  }

  limpiar() {
    if ( this.f.idUsuario.value ) {
      this.f.telefono.setValue( null );
      this.f.correoElectronico.setValue( null );
    }
    this.f.idUsuario.setValue( null );
  }
}
